import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../thema/style";
import ProductItem from "./ProductItem";
import Loading from "./shared/Loading";
import { connect } from "react-redux";
import { featuredProducts } from "../store/actions/product";
class FeaturedProducts extends Component {
  componentDidMount() {
    if (this.props.product.featuredProducts.length === 0)
      this.props.featuredProducts();
  }

  render() {
    return (
      <div className={"row"}>
        <div className={"col-md-12"}>
          <div className={styles.headerSectionTitle}>
            <h2 className={styles.featuredProductTitle}>
              Öne Çıkan Ürünler
              <span>
                <span>
                  <FontAwesomeIcon
                    icon={["fas", "burn"]}
                    size="lg"
                    color={"#88c000"}
                  />
                </span>
              </span>
            </h2>
          </div>
        </div>
        <div className={"container"}>
          <div className={"row"}>
            {this.props.product.featuredFetching ? (
              <Loading text="Öne çıkan ürünler yükleniyor..." />
            ) : (
              this.props.product.featuredProducts.map((product, i) => (
                <ProductItem {...product} key={i} />
              ))
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ product }) => {
  return { product };
};

const mapDispatchToProps = {
  featuredProducts
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeaturedProducts);



// WEBPACK FOOTER //
// ./src/components/FeaturedProducts.js